import type { ChatProductItem } from "schemas/generated/chatMessage";

import React from "react";

import { Image } from "lucide-react";

export const ProductToken: React.FC<{ data: ChatProductItem }> = ({ data }) => {
  let featuredMediaUrl = data.featuredMedia?.url;
  if (data.media?.[0]?.type === "image") {
    featuredMediaUrl = data.media[0].url;
  }

  return (
    <span className="inline-flex items-center align-bottom pt-1 max-w-full">
      {featuredMediaUrl ? (
        <img
          src={featuredMediaUrl}
          alt={data.title}
          className="w-5 h-5 object-cover rounded-sm inline align-baseline mr-1 border border-border"
        />
      ) : (
        <Image className="w-5 h-5 object-cover text-placeholder rounded-sm inline align-baseline mr-1 border border-border " />
      )}
      <span className="font-medium text-default truncate">{data.title}</span>
    </span>
  );
};
